<div class="grid-2col_auto mt-3 input-grid-gaps">
  <app-select-input [form]="form" id="type" label="person.address.fields.type" [autoDisplayFirst]="true"
  [staticOptions]="personAddressEnumOptions" valueKey="value"></app-select-input>
  <app-address-input [form]="form" id="address" label="person.address.fields.address"></app-address-input>
  <app-date-input [form]="form" id="validFrom"></app-date-input>
  <app-date-input [form]="form" id="validTo" timeType="endOfDay"></app-date-input>
</div>

@if (this.err) {
  <div class="text-danger mt-2">{{ this.err | translate }}</div>
}
